// src/app/features/store/store.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';  // <-- Import necesario
// Rutas del Store
import { StoreRoutingModule } from './store-routing.module';

// Componentes del Store
import { StoreLayoutComponent } from './components/store-layout/store-layout.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { CartComponent } from './components/cart/cart.component';
import { CheckoutComponent } from './components/checkout/checkout.component';

// (Opcional) Si usas algún módulo compartido
// import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    StoreLayoutComponent,
    ProductListComponent,
    ProductDetailComponent,
    CartComponent,
    CheckoutComponent
  ],
  imports: [
    CommonModule,
    StoreRoutingModule,
    FormsModule
    // SharedModule
  ]
})
export class StoreModule { }
